import {
  collection,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDocs,
} from 'firebase/firestore'
import type {
  QueryDocumentSnapshot,
  DocumentData,
  OrderByDirection,
  QueryConstraint,
} from 'firebase/firestore'
import { db } from '@/lib/firebase'

export interface PaginatedResult<T> {
  items: T[]
  lastDoc: QueryDocumentSnapshot<DocumentData> | null
}

export async function getPaginatedCollection<T>(options: {
  collectionName: string
  churchId: string
  pageParam: QueryDocumentSnapshot<DocumentData> | null
  orderField: string
  orderDirection?: OrderByDirection
  pageSize: number
  mapper: (doc: QueryDocumentSnapshot<DocumentData>) => T
}): Promise<PaginatedResult<T>> {
  const constraints: QueryConstraint[] = [
    where('churchId', '==', options.churchId),
    orderBy(options.orderField, options.orderDirection ?? 'asc'),
  ]
  if (options.pageParam) constraints.push(startAfter(options.pageParam))
  constraints.push(limit(options.pageSize))

  const snapshot = await getDocs(
    query(collection(db, options.collectionName), ...constraints),
  )
  const items = snapshot.docs.map(options.mapper)
  const lastDoc = snapshot.docs[snapshot.docs.length - 1] ?? null
  return { items, lastDoc }
}
